module.exports = __webpack_public_path__ + "static/media/iot-logo.b42814c0.png";